import { NgModule } from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';

import { ActionTooltipDirective } from './action-tooltip.directive';
import { ActionTooltipComponent } from './action-tooltip.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { UzurvPipesModule } from '@uzurv/core';

@NgModule({
  declarations: [ActionTooltipDirective, ActionTooltipComponent],
  imports: [CommonModule, OverlayModule, MatButtonModule, UzurvPipesModule],
  exports: [ActionTooltipDirective]
})
export class ActionTooltipModule {}
